<script>
    $("#myCarousel").carousel({
        interval: false
    });
</script>

<svg class="text" viewBox="0 0 800 600">
    <symbol id="s-text">
      <text text-anchor="middle"
            x="50%"
            y="35%"
            class="text--line"
            >
        STG DRIVE
      </text>
      <text text-anchor="middle"
            x="50%"
            y="68%"
            class="text--line2"
            >
       
      </text>
      
    </symbol>
    
    <g class="g-ants">
      <use xlink:href="#s-text"
        class="text-copy"></use>     
      <use xlink:href="#s-text"
        class="text-copy"></use>     
      <use xlink:href="#s-text"
        class="text-copy"></use>     
      <use xlink:href="#s-text"
        class="text-copy"></use>     
      <use xlink:href="#s-text"
        class="text-copy"></use>     
    </g>
    
    
  </svg>



    <div style="padding-top: 60px;">
      
    </div>



    <div class="sect sect--padding-top ">
        <div class="container">
            <div class="row">
                
                <div class="col-md-12">
 

                    <div class="site  ">
                        
 
   
                       

        
                        <h2 class="site__subtitle">STG Maroc est une société opérant dans le secteur des nouvelles technologies et spécialisée dans la télématique embarquée.</h2>
                        <div class="site__box-link">
                            <a class="btn btn--width" href="">Pricing</a>
                            <a class="btn btn--revert btn--width" href="">Contact</a>
                        </div>
                        <img class="site__img" src="https://image.ibb.co/c7grYb/image3015.png">
                    </div>
                </div>
            </div>
        </div>
    </div>



    <div class="sect sect--padding-bottom">
        <div class="container">
            <div class="row row--center">
                <h1 class="row__title">
                    NOS POINTS FORTS  <br>
                </h1>
                <h2 class="row__sub">NOS POINTS FORTS </h2>
            </div>
            <div class="row row--center row--margin">
                <div class="col-md-4 col-sm-4 price-box price-box--purple">
                    <div class="price-box__wrap">
                        <div class="price-box__img"></div>
                        <h1 class="price-box__title">
                            GESTION DE FLOTTE
                        </h1>
                        <p class="price-box__people">
                           STG DRIVE
                        </p>
                       
                        <p class="price-box__feat">
                            Description
                        </p>
                        <ul class="price-box__list">
                            <li class="price-box__list-el">Offre une mine d'informations <br>sur votre flotte de véhicules et d’engins, et sur votre personnel de terrain. <br><br></li>
                        
                        </ul>
                        <div class="price-box__btn">
                            <a class="btn btn--purple btn--width">Plus Info</a>
                        </div>
                    </div>
                </div>
                <!-- second -->
                <div class="col-md-4 col-sm-4 price-box price-box--violet">
                    <div class="price-box__wrap">
                        <div class="price-box__img"></div>
                        <h1 class="price-box__title">
                            BOÎTE <br> NOIRE

                        </h1>
                        <p class="price-box__people">
                            STG DRIVE
                        </p>
                       
                        <p class="price-box__feat">
                            Description
                        </p>
                        <ul class="price-box__list">
                            <li class="price-box__list-el">Grâce à sa technologie avancée, le boîtier de STG comporte une boîte noire qui permet une reconstruction en 3D des accidents.

                            </li>
                            
                        </ul>
                        <div class="price-box__btn">
                            <a class="btn btn--violet btn--width">Plus Info</a>
                        </div>
                    </div>
                </div>



                <!-- terzo -->
                <div class="col-md-4 col-sm-4 price-box price-box--blue">
                    <div class="price-box__wrap">
                        <div class="price-box__img"></div>
                        <h1 class="price-box__title">
                            COMPORTEMENT DE CONDUITE

                        </h1> 
                        <p class="price-box__people">
                            STG DRIVE
                        </p>
                        
                        <p class="price-box__feat">
                            Description
                        </p>
                        <ul class="price-box__list">
                            <li class="price-box__list-el">Avec cette analyse, vous réduisez <br> les coûts généraux <br> de transport de vos chauffeurs <br> mais aussi les risques d’accident.</li>
                     
                        </ul>
                        <div class="price-box__btn">
                            <a class="btn btn--blue btn--width">Plus Info</a>
                        </div>
                    </div>
                </div>



            </div>
        </div>
    </div>






    <div class="container-fluid  ">
        <div class="row pt-5 pl-4 ">

            <div class="col-6 col-md-3 pl-5">

                <a href='' class='hero-box' style="background-image: url(https://image.radins.com/media/leadgen_article_news/690/479/aa75c5626d25a7f67c0e78f250805f04.jpeg);">
                    <span class='hero-box__circle hero-box__circle--blue'></span>
                    <h2 class='hero-box__title'>GÉOLOCALISATION <br> ET SÉCURISATION</h2>
                    <p class='hero-box__body'>Grâce au boîtier STG installé dans vos véhicules, vous êtes capable de connaître en temps réel la situation exacte de vos véhicules.</p>
                </a>


            </div>



            <div class="col-6 col-md-3 pl-5">



                <a href='' class='hero-box' style="background-image: url(http://www.stg.ma/site2/images/solution_2.jpg);">
                    <span class='hero-box__circle hero-box__circle--jaune'></span>
                    <h2 class='hero-box__title'>GESTION DES <br>SERVICES <br>SUR TERRAIN</h2>
                    <p class='hero-box__body'>La solution STG vous permet de choisir vos meilleures ressources pour les différentes interventions à assurer.</p>
                </a>


            </div>
            <div class="col-6 col-md-3 pl-5">

                <a href='' class='hero-box' style="background-image: url(http://www.stg.ma/site2/images/solution_3.jpg);">
                    <span class='hero-box__circle hero-box__circle--green'></span>
                    <h2 class='hero-box__title'>ANALYSE DU COMPORTEMENT DE CONDUITE</h2>
                    <p class='hero-box__body'>Un petit changement dans le comportement de vos conducteurs peut vous faire d’énormes économies chaque mois.</p>
                </a>



            </div>
            <div class="col-6 col-md-3 pl-5">
                <a href='' class='hero-box' style="background-image: url(http://www.stg.ma/site2/images/solution_4.jpg);">
                    <span class='hero-box__circle hero-box__circle--orange'></span>
                    <h2 class='hero-box__title'>GESTION DE FLOTTES <br>ET DES ASSETS</h2>
                    <p class='hero-box__body'>L’analyse des données collectées de vos véhicules en temps réel permettent d’optimiser la gestion de votre flotte.</p>
                </a>
            </div>



        </div>


    </div>


    <div class="container-fluid mb-3">
        <div class="row pt-3 pl-4 ">





            <div class="col-6 col-md-12 pl-5">







            </div>


        </div>

        <div class="row pt-3 pl-4 ">
            <div class="col-6 col-md-4 w-100 pr-0 pl-5">




            </div>
            <div class="col-6 col-md-4 w-100 ">

            </div>
            <div class="col-6 col-md-4 w-100 pl-0">

            </div>
        </div>





    </div>

    <!--contt-->









    <div class="sect sect--white">
        <div class="container " style="    max-width: 94%;">
            <div class="row pb-2">
                <h1 class="row__title">
                    Success Stories
                </h1>
                <h2 class="row__sub">Companies you <span class="row__sub--light">(will)</span> propably know</h2>
            </div>
            <div class="row pb-2">
                <div class="col-md-6">
                    <canvas class="elhoo_body_canvas" id="myChart"></canvas>
                </div>
                <div class="col-md-6">
                    <canvas class="elhoo_body_canvas" id="myChart2"></canvas>
                </div>
            </div>
            <div class="row pb-2">
                <div class="col-md-6">
                    <canvas class="elhoo_body_canvas" id="myChart3"></canvas>
                </div>
                <div class="col-md-6">
                    <canvas class="elhoo_body_canvas" id="myChart4"></canvas>
                </div>
            </div>
        </div>
    </div>

    <div class="slider">
		<input type="radio" name="testimonial" id="t-1">
		<input type="radio" name="testimonial" id="t-2">
		<input type="radio" name="testimonial" id="t-3" checked>
		<input type="radio" name="testimonial" id="t-4">
		<input type="radio" name="testimonial" id="t-5">
		<div class="testimonials">
			<label class="item" for="t-1">
				<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARMAAAC3CAMAAAAGjUrGAAAA8FBMVEX///8kg8YlQI7SOzQAdsAjPo0dOosAdL8NMon7/f4AeMEhgcUgPIzz9Pna3OmQvuF4tN2iyeZqqtnCx9zR1uZUZKAtSJUTN4vt7vWFtdzRNS3r8/ng5fGLveE+l9DLz+Fhb6ZqotOw0+uyudRoeK+AsdpOXp3PKB754+Jhbqbprq3TQDnRMin88/LOIRbi7vjklpP009HB2+7T5PKNmMDYYVvopKHghIDVTEXddXHWVE756unba2ZWntM/lM712tjtvLrkkY7MFQA9VpwAKoTwxMLZZmA1jszVUUmpsM51gbQ3TpebpMYAI4F+i7mSmsGSE4EIAAAM0UlEQVR4nO2bi1raShCAEwiXJCAEkVtAJQqogCBRuWhAKzTeat//bc7MbpCEBCvWYk+/+bUtEBI2P7Ozs5tUEAiCIAiCIAiCIAiCIAiCIAiCIAiCIAiCIAiCIAiCIAiCIAiCIAiCIAiCIAiCIAiC+Bdpt6+Ozmazm5uTBTc3s7PJ0VW7/dWN2zBg4mx2ctm97fevL+4HzXC45BAONweD0cX1sN/vXoKdo39eTXsyuwEV/eH3ixGYKLUAbsIFPG8xSs37i+/D7snN0Ve3+0/QvprcXN6CipErJsKL6Cj5xMztlFqlcHM07F9O/p2AaR+dnfS/j+4xKBan32o0GqdAozVXwV5jLzXgRZ8aiJnR8B+Il/bZye1FE8+V22ihCXbKgxHki9vLG8gWLq4mZzesX92H+dtKXjGtRmt0efbVZ/VR2lez7nBUYoHAMwNkzvvRdR9ygz9tysDS/pPZye31aBBuLYlpnZ4O+rP/Vy9qQ1e56V4PSk6/aLKIABVnMLjO3wQKkrqud0yz1zMMQ2PAg16vZ5odXU86itpHs27/+p51OpeWRuO+e/a/0NK+uoIvt3vdbDAdKAN6x8nsNShkGT2gCLBQzFhjW1RVxYMK2GOrltKMXgfksOOeXd4O75ulllfL9c3fPUi3jyARwDcKOr6dtpqjCxglTm7OrvhWGQMCRaSKNTShOiZQgKiKLvCJ6mxWbVBj9MwOhkwbe9JgScuoO/+ET2HyWUdrX51BvQE9v9n4dtoID65Z4pzwr1DWsW9oqVqVxcRrKIjvgamBoKmCGOblaHY5HLRcWlqNZv/TBqJJ92LUv7z5vfG+jT0FonqEaa9Ral70seicXDk2Oj0jBf3DZv1D5bzLhU+MKtpWUethP7qanVyXGq3FSNQKX598ipV2dwBdvtH8jplvfTHYUSBvwIg5aEFXKY2+g42zuQ0BYsNIQR95lbG+Cb8YVRxXK4YpYLR0R61GyWPld2M+KeBcAwZK5iV8fzHssirhHSrABKvKL6D+wjxaGg2ho8BkzbGRNLGfYDcRPxgWb4uxxzWtgw25GYaXrPyGELmXtjIpU2bTUaguR2H4oiEWnfESBonZZHI0ZwLx4EzThsNrmJ7A52MShbRx0T+ZsXKLH1Y3jVQaQ0P8aCd5pxZxnDF0rF5um24rpevZB410tLETh2nWO/HLn1wOR83S6TcEq2pMYU0Ofhgrtr/xrZAzBhfD25OFCwDyRiqza4vzjPGHdLi92BUIFuHqtnTqSrfh/gc6kKntQhp3jqsoolWZe2Gl0QlEAwuG+8GAKxlA2Xnx/XoIJfhtl0eF+3hyp6dVMmw0+XOREWxFUTM9DPWuK1bCjcHJuzMjlowdIz1WJG8loEiSuJvRTN1fV79xKDmZhMjQ0hAacID3D6yfrEVRxpouC+3L+0V92zodTt5qfVJPJrF4xhFRy4xFbHzgobEAgIEOS6MOvj8pe2EHcWpPY157KpIyD7kvQ1XsFFQtR90RmzLjbGp0cftW/+mla8Ua1oz8vN9qv1M0QhGwa2VqxZTmIlXBg+zygWRRfG/sxN9ElWwNrJz170dDHB6WO7cvToyqElunZnytqANwRpK/RMUc1l4L8kp79t7pYEezfucL/csELINfkl1NabzofzeyqY3/ljD/XLDat+aToDWRzdQYBt1/C+gwdhXiI7m+D04SqrRfjxArE8lGUOen6vyyWZ+TxwJaqrLy4aNCeKzohqW+aUVVoF5OGS40Hyk/xWKliH8qFfwXH6X9ZHxULU6G/SJ8zcS2rF0fY3WppaoFI83vCXG0mBlVWqUFih8Y5n/5OUtVi+x74aMIHQuHNNsMOmJP8bRUTH8kg6xC1yw1YFyGVzLm533Kh0AnqhjcCkNZNFS1jE8UwjErbP7nMSJ+uRHmRFVXNMNxAm8YF/9MS+VesWovvCzMy4Xy3va72MOfAuxSgAfbe4FkfWwh2S32YWX+jFOW0Yki9ngjPCQdJ9heK6WvPq3fJQnzerZYjkVZpsNeK2QfHp/iQeTzeedf5zn8xKc7W7DT+fT1Lb8kmgDyuQc8y/JdPMGIhEKh6E4ZnYgGNmPrMJRjPN0huW2ZOVFVO6P9QSMM2TTAC1jh7gt7LyAkik3EP24iQSSiz+zUooFbg3aAX1TyzJTsTBML8sxJVeNK4lEHJvLHAXdi14w/bYSjZxRHSfYlx4W8l2g9C7s9r7ML7hXiSg7jnlfRiY4rIbjFe8g4cyKNN2QEZs22UsM2Jg/q+eiaZ/cCbS3srLdXIvGTKXn07sacsCxTWFbiOIlVN6XEHEsWflby+Sm/npFQ9G4bdjzIrRUnkfi5o8S7G3OCyI/LSuZxUu1syElNUTtMSWjNIAmF8o/Q1ORjfh0nkR8vqKTwkkh4N8ydyC9x307zONmQE8OOYVqTHyJrK4mEDmDP7bu1dpyiR1Diy1tzJy++KNm0E7km7WIjs7l1Ow5mWPjG5Z9r7Tg9xk9L/vSfuOPkPCDqInHsoxtzYogK1kjluj9gf0kcB+LszhpOInGu5HnqP3GeY4OUwCc5TjaSY+WilIFWys9TTxsS0TfJ87+fCrhn3LVh6XzYYRL8D3ucPyxwJUu5ZO5Efl7OMl/gxBwrWBEUPENOJFLfP1xi/3ifc7x/zH739+vncIDyy87xKztPXiVPO17qj6hEfpgGZaDoTkF+WJHnN+rEUG3sow/uMImEXrJJHwUfbBLinpgUsseeU5o+eyctW1m2HHYQDzzx6HH5ILciXW/SiV6UavA58p07TKKH5Q8ezjsERSOB0/ltd2EYWXSVxM5DPe/e4uqIm3TSqSoaNHzLMwqwOcxHSHoT5PQl6E3b7gEumrtbSMk9uWQlQne5L3JisVHHm2ETxwcrpvlZ19Q+y1KDPgdDYq/uDpPINOt7B4aSS0k+dHC4eOqKmVA08fP5aSGYOdE248QcswUc72Qsksjd1YNx5UtW1neqVpXBBy/PuJPfwSI35byhmmbns+3Wls9vJw8DawCcJR48vTqKbNYJW+c79jYM1wB+RZwNxJqiSJKkqrE0HGXr2FOpTB9Qmj1fe+/5IimeywrBTvI5qFsPcou42agTS8W+8zINaNjbTJ8xCnbVdK/XS6sSDl7bCU9WyjFpML/vwKewLips7bgSTvxuSwh2Er/DXvdVTiDH4orj9tpO8k84NhmxMZ5rJmbB34VHz+lNH2HgTVpSURaKqsIXz1yBFInX8QhBTqZ1TFVuJxvtO3pNSuH3vfaUmM33ZUupybj+IqGZrHvYgBIWv+ueIhpyUeFKyq4umuAVbYATqHV5277KCSQEtnZyvmagJHJ4xqZko4yigrNImNZ5pO1j10nDtC2lqBpfPFtMchIRVtH6ncDkfF4JfJUT+I7ZwFO+W28KGH/BU8pIVRlzkoSLDeW6Z3qQx9m9LqoVTeVKCocL74nQOVey7CSSrx/Mm+Z2kt+kEz3D5oDC9lprbHzhpAMBgE1VRZ1NYjwZFhOooEl2xlZTfA1psT0a+smKG3nZSSJ/vMdaZQY6kaofvlS+FobIRh75oB4PnJEGkmfVfyU2Bhl6FdOokPQOxDyQ8Aqvypa/k66VoihftddxwdnjJJF4RJNCp1gTvrDvQJZVbPxW5L3HUDz/y7IE5/1QvDxgx7CVioC9j5U4e9Oo+7pECE/ClERVLTIl59P55Q7Yht1K0FM2d5KYX+eI5lj4CJ2Mwp1El5xIm1qjNsc8zQqF7fP6U87Nk/fpK4kdzLCaInbYLDKjs0VU3PIaSPsYSGko13CKKcjn03w0n2cLL6CLKxFF5mQadS6GxZ/YdTChZylqEZ0kXq+hxX9s1olgqIpzDTBZ3nofeBVTtmIZrpRdU53PghzKLJDgyOwsZPfVUtY99KKoYJzIW67LqEyJMQaT6KTsugp7gAGU2ty1DCzQrd7au/VELF5xMF+1SKqpTgT60Wt4A3TARjllx3Ytpcgeu2/CEDbqBC+cKGJxzeVfOaPsCjixZkVfIFZsd8U4gVced1nfWd5QU2MWHLoYtNdGnQimHZPEdG+dT+zZMYytnjpedduDqe6u2KKPJdEwRNFnDKYaSloWrGAnGxt3OHLFVmF+azu3UrH5fYb9sgfws8xYGcvsC7fxWcCNWhVLTacqy7AbvcaSbQiGLRaXbwADV1jfWYrlv2FM0zLKRp3gDbTVsfjG3X0SLgrgLfXOU1XBes3E++wkhW8DYrGYBD8x9lb19eVX+Cvq2MBrbb7tijJm+drid/XxT2M7sQao6oad8P9ZEXT73ipw1DArnpcW8VB8E+x1pv89Nef2o1RtBdpm6liCIAiCIAiCIAiCIAiCIAiCIAiCIAiCIAiCIAiCIAiCIAiCIAiCIAiCIAiCIAiCIAhiNf8BYYMcqYfv9LMAAAAASUVORK5CYII=" alt="picture">
				<p>"
                    La sécurité de nos voyageurs et le respect des horaires sont au centre de nos préoccupations. La solution de STG est un élément clé pour atteindre ces objectifs.
                "</p>
				<h2>- M. Ahmed Reda Douihri, Directeur Activité Transport CTM</h2>
			</label>
			<label class="item" for="t-2">
				<img src="https://startupbrics.com/wp-content/uploads/2013/06/logo-orange-300x178.jpg" alt="picture">
				<p>"
                    Orange est leader sur la data avec une excellente couverture dans les grandes villes. Nous étions le premier opérateur marocain à lancer la 4G. STG Maroc apporte une vision dynamique, créative et un vrai savoir faire dans le domaine de la gestion de flotte.
                ."</p>
				<h2>- M. Brahim Sbai, Directeur central</h2>
			</label>
			<label class="item" for="t-3">
				<img src="https://media-exp1.licdn.com/dms/image/C510BAQGSJFYgWja0XA/company-logo_200_200/0?e=2159024400&v=beta&t=o9oMXaR34MzRo2lpL1QX61CgwIXYDtJDBxkHfwa8hTY" alt="picture">
				<p>"
                    Grâce au partenariat établi depuis fin 2013 avec la société STG Maroc, nous sommes en mesure de proposer à nos clients, gestionnaires de flottes, un dispositif complet de prévention visant à réduire la sinistralité de leur parc. Grâce à ses équipes compét.
                "</p>
				<h2>- M. Yassine Lahlou, Directeur Général Adjoint RMA WATANYA</h2>
			</label>
			<label class="item" for="t-4">
				<img src="data:image/jpeg;base64,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" alt="picture">
				<p>"
                    La solution STG est une solution proposé au client industriel, c'est une solution globale et permet au consommateur de suivre la consommation du carburant.
                "</p>
				<h2>- M.Said El Baghdadi, Directeur Général</h2>
			</label>
			<label class="item" for="t-5">
				<img src="https://www.infopoint.ma/backoffice/uploads/lodive-Tanger-2017-10-09-02-54-57.png" alt="picture">
				<p>"
                    Nous sommes très satisfaits des services de STG Maroc. La qualité de leur boîtier et la réactivité de leur équipe nous aident à prendre les meilleures décisions pour un rendement optimal de notre flotte.
                "</p>
				<h2>- M. Yassine Berrada, Directeur Général Lodive</h2>
			</label>
		</div>
		<div class="dots">
			<label for="t-1"></label>
			<label for="t-2"></label>
			<label for="t-3"></label>
			<label for="t-4"></label>
			<label for="t-5"></label>
		</div>
	</div>






    <div class="sect sect--white sect--no-padding">
        <div class="container">
            <div class="row row--center">
                <div class="col-md-3 col-xs-6 col-sm-6 partner">
                    <a href="#" class="partner__link">
                        <img class="partner_img" src="https://www.stg.ma/site2/images/orange_logo.png">
                    </a>
                </div>

                <div class="col-md-3  col-xs-6 col-sm-6 partner">
                    <a href="#" class="partner__link">
                        <img class="partner_img" src="https://www.stg.ma/site2/images/afriquia_logo.png">
                    </a>
                </div>


                <div class="col-md-3 col-xs-6 col-sm-6 partner">
                    <a href="#" class="partner__link">
                        <img class="partner_img" src="https://www.stg.ma/site2/images/cat_logo.png">
                    </a>
                </div>

                <div class="col-md-3 col-xs-6 col-sm-6 partner">
                    <a href="#" class="partner__link">
                        <img class="partner_img" src="https://www.stg.ma/site2/images/garmin_logo.png">
                    </a>
                </div>


            </div>
            <div class="row row--center">
                <div class="col-md-3 col-xs-6 col-sm-6 partner">
                    <a href="#" class="partner__link">
                        <img class="partner_img" src="https://www.stg.ma/site2/images/RMA_logo.png">
                    </a>
                </div>

                <div class="col-md-3 col-xs-6 col-sm-6 partner">
                    <a href="#" class="partner__link">
                        <img class="partner_img" src="https://www.stg.ma/site2/images/maghrebail_logo-01.png">
                    </a>
                </div>


                <div class="col-md-3 col-xs-6 col-sm-6 partner">
                    <a href="#" class="partner__link">
                        <img class="partner_img" src="https://www.stg.ma/site2/images/MAN_logo.png">
                    </a>
                </div>

                <div class="col-md-3 col-xs-6 col-sm-6 partner">
                    <a href="#" class="partner__link">
                        <img class="partner_img" src="">
                    </a>
                </div>
            </div>
        </div>
    </div>

  



    <footer class="new_footer_area bg_color">
        <div class="new_footer_top">
            <div class="container">
                <div class="row">
                    <div class="col-lg-3 col-md-6">
                        <div class="f_widget company_widget wow fadeInLeft" data-wow-delay="0.2s" style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInLeft;">
                            <h3 class="f-title f_600 t_color f_size_18">Get in Touch</h3>
                            <p>CONTACTEZ-NOUS
                                MAINTENANT.!</p>
                            <form action="#" class="f_subscribe_two mailchimp" method="post" novalidate="true" _lpchecked="1">
                                <input type="text" name="EMAIL" class="form-control memail" placeholder="Email">
                                <button class="btn btn_get btn_get_two" type="submit">Subscribe</button>
                                <p class="mchimp-errmessage" style="display: none;"></p>
                                <p class="mchimp-sucmessage" style="display: none;"></p>
                            </form>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="f_widget about-widget pl_70 wow fadeInLeft" data-wow-delay="0.4s" style="visibility: visible; animation-delay: 0.4s; animation-name: fadeInLeft;">
                            <h3 class="f-title f_600 t_color f_size_18">Contacts</h3>
                            <ul class="list-unstyled f_list">
                                <p><i class="fas fa-phone"></i>  Tél : +212 (0) 5 39 340 734
</p>
                            <p><i class="fas fa-fax"></i> Fax : +212 (0) 5 39 340 735</p>
                            <p><i class="fas fa-at"></i> Email : contact@stg.ma</p>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="f_widget about-widget pl_70 wow fadeInLeft" data-wow-delay="0.6s" style="visibility: visible; animation-delay: 0.6s; animation-name: fadeInLeft;">
                            <h3 class="f-title f_600 t_color f_size_18">Nos Services</h3>
                            <ul class="list-unstyled f_list">
                                <li><a href="#"><i class="fas fa-desktop"></i> GESTION DE FLOTTE</a></li>
                                <li><a href="#"><i class="fas fa-box"></i> BOÎTE NOIRE</a></li>
                                <li><a href="#"> <i class="fas fa-car"></i> COMPORTEMENT DE CONDUITE</a></li>
                                <li><a href="#"><i class="fas fa-gas-pump"></i> CONSOMMATION ET VOL DU GASOIL</a></li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6">
                        <div class="f_widget social-widget pl_70 wow fadeInLeft" data-wow-delay="0.8s" style="visibility: visible; animation-delay: 0.8s; animation-name: fadeInLeft;">
                            <h3 class="f-title f_600 t_color f_size_18"></h3>
                            <div class="f_social_icon">
                                <a href="#" class="fab fa-facebook"></a>
                                <a href="#" class="fab fa-twitter"></a>
                                <a href="#" class="fab fa-linkedin"></a>
                                <a href="#" class="fab fa-pinterest"></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer_bg">
                <div class="footer_bg_one"></div>
                <div class="footer_bg_two"></div>
            </div>
        </div>
        <div class="footer_bottom">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-sm-7">
                        <p class="mb-0 f_400">© STG Maroc 2020 All rights reserved.</p>
                    </div>
                    <div class="col-lg-6 col-sm-5 text-right">
                        <ul >
                            <li><a href="#">Terms of Service</a></li>
                            <li><a href="#">Privacy Policy</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </footer>